/*
  Kashmir Saffron — Hero Slider behavior
  Section: sections/heroo.liquid

  One instance per .ks-hero-slider element on the page. All configuration is
  read from data-* attributes on that element, so this file stays static and
  cacheable while the theme editor still drives every setting.
*/

(function () {
  'use strict';

  function initKashmirHeroSlider(root) {
    var sectionId = root.id;

    if (!root) return;

    window.KashmirHeroSliders = window.KashmirHeroSliders || {};

    if (
      window.KashmirHeroSliders[sectionId] &&
      typeof window.KashmirHeroSliders[sectionId].destroy === 'function'
    ) {
      window.KashmirHeroSliders[sectionId].destroy();
    }

    var track = root.querySelector('[data-ks-hero-track]');
    var viewport = root.querySelector('[data-ks-hero-viewport]');
    var slides = Array.prototype.slice.call(
      root.querySelectorAll('[data-ks-hero-slide]')
    );
    var previousButton = root.querySelector('[data-ks-hero-prev]');
    var nextButton = root.querySelector('[data-ks-hero-next]');
    var autoplayButton = root.querySelector('[data-ks-hero-autoplay]');
    var dots = Array.prototype.slice.call(
      root.querySelectorAll('[data-ks-hero-dot]')
    );

    if (!track || !viewport || slides.length < 1) return;

    var autoplayEnabled = root.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed =
      parseInt(root.getAttribute('data-autoplay-speed'), 10) || 5000;
    var pauseOnHover = root.getAttribute('data-pause-hover') === 'true';
    var loopEnabled = root.getAttribute('data-loop') === 'true';
    var transitionSpeed =
      parseInt(root.getAttribute('data-transition-speed'), 10) || 700;

    var reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );
    var currentIndex = 0;
    var autoplayTimer = null;
    var resumeTimer = null;
    var resizeTimer = null;
    var observer = null;
    var isVisible = true;
    var isUserPaused = false;
    var isHovering = false;
    var isFocusWithin = false;
    var isPointerDown = false;
    var pointerStartX = 0;
    var pointerCurrentX = 0;
    var pointerId = null;
    var destroyed = false;
    var cleanup = [];

    autoplaySpeed = Math.max(2000, autoplaySpeed);

    function normalizeIndex(index) {
      if (loopEnabled) {
        if (index < 0) return slides.length - 1;
        if (index >= slides.length) return 0;
        return index;
      }

      return Math.max(0, Math.min(index, slides.length - 1));
    }

    function updateControls() {
      dots.forEach(function (dot, index) {
        var active = index === currentIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      slides.forEach(function (slide, index) {
        var active = index === currentIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');

        var focusable = slide.querySelectorAll(
          'a, button, input, select, textarea, [tabindex]'
        );

        focusable.forEach(function (element) {
          if (active) {
            if (element.hasAttribute('data-ks-original-tabindex')) {
              var originalTabindex = element.getAttribute(
                'data-ks-original-tabindex'
              );

              if (originalTabindex === '') {
                element.removeAttribute('tabindex');
              } else {
                element.setAttribute('tabindex', originalTabindex);
              }

              element.removeAttribute('data-ks-original-tabindex');
            }
          } else {
            if (!element.hasAttribute('data-ks-original-tabindex')) {
              element.setAttribute(
                'data-ks-original-tabindex',
                element.getAttribute('tabindex') || ''
              );
            }

            element.setAttribute('tabindex', '-1');
          }
        });
      });

      if (!loopEnabled) {
        if (previousButton) {
          previousButton.disabled = currentIndex === 0;
        }

        if (nextButton) {
          nextButton.disabled = currentIndex === slides.length - 1;
        }
      }
    }

    function moveTrack(animate) {
      track.style.transitionDuration =
        animate && !reducedMotion.matches ? transitionSpeed + 'ms' : '0ms';

      track.style.transform =
        'translate3d(' + currentIndex * -100 + '%, 0, 0)';
    }

    function goTo(index, options) {
      options = options || {};

      var nextIndex = normalizeIndex(index);

      if (nextIndex === currentIndex && !options.force) {
        if (options.restartAutoplay) {
          restartAutoplay();
        }
        return;
      }

      currentIndex = nextIndex;
      moveTrack(options.animate !== false);
      updateControls();

      if (options.restartAutoplay !== false) {
        restartAutoplay();
      }
    }

    function next(options) {
      if (!loopEnabled && currentIndex >= slides.length - 1) {
        stopAutoplay();
        return;
      }

      goTo(currentIndex + 1, options);
    }

    function previous(options) {
      if (!loopEnabled && currentIndex <= 0) {
        return;
      }

      goTo(currentIndex - 1, options);
    }

    function canAutoplay() {
      return (
        !destroyed &&
        autoplayEnabled &&
        slides.length > 1 &&
        !isUserPaused &&
        !isHovering &&
        !isFocusWithin &&
        !document.hidden &&
        isVisible &&
        !reducedMotion.matches
      );
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();

      if (!canAutoplay()) return;

      autoplayTimer = window.setInterval(function () {
        next({
          animate: true,
          restartAutoplay: false
        });
      }, autoplaySpeed);
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    function pauseTemporarily() {
      window.clearTimeout(resumeTimer);
      stopAutoplay();
    }

    function resumeTemporarily() {
      window.clearTimeout(resumeTimer);

      resumeTimer = window.setTimeout(function () {
        startAutoplay();
      }, 1200);
    }

    function handleMouseEnter() {
      isHovering = true;
      pauseTemporarily();
    }

    function handleMouseLeave() {
      isHovering = false;
      resumeTemporarily();
    }

    function handleFocusIn() {
      isFocusWithin = true;
      pauseTemporarily();
    }

    function handleFocusOut(event) {
      if (event.relatedTarget && root.contains(event.relatedTarget)) return;

      isFocusWithin = false;
      resumeTemporarily();
    }

    function setAutoplayButtonState() {
      if (!autoplayButton) return;

      autoplayButton.classList.toggle('is-paused', isUserPaused);
      autoplayButton.setAttribute(
        'aria-label',
        isUserPaused ? 'Play slideshow' : 'Pause slideshow'
      );
      autoplayButton.setAttribute(
        'aria-pressed',
        isUserPaused ? 'true' : 'false'
      );
    }


    /*
     * Keep CTA/link navigation native. We intentionally do not call
     * preventDefault() here. This handler only stops slider-level click
     * handling from ever hijacking a link click.
     */
    function handleInteractiveClick(event) {
      var link = event.target.closest('a[href]');
      if (!link || !root.contains(link)) return;

      isPointerDown = false;
      pointerId = null;
    }

    function handlePreviousClick() {
      pauseTemporarily();
      previous({ animate: true, restartAutoplay: false });
      resumeTemporarily();
    }

    function handleNextClick() {
      pauseTemporarily();
      next({ animate: true, restartAutoplay: false });
      resumeTemporarily();
    }

    function handleDotClick(event) {
      var index = parseInt(
        event.currentTarget.getAttribute('data-ks-hero-dot'),
        10
      );

      pauseTemporarily();
      goTo(index, { animate: true, restartAutoplay: false });
      resumeTemporarily();
    }

    function handleAutoplayClick() {
      isUserPaused = !isUserPaused;
      setAutoplayButtonState();

      if (isUserPaused) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    }

    function handlePointerDown(event) {
      /*
       * IMPORTANT:
       * Do not start slider dragging when the pointer starts on a real
       * interactive element. Capturing the pointer from an <a> element can
       * prevent Shopify CTA links from navigating normally.
       */
      var interactiveElement = event.target.closest(
        'a, button, input, select, textarea, label, summary, [role="button"], [data-no-slider-drag]'
      );

      if (interactiveElement) {
        isPointerDown = false;
        pointerId = null;
        return;
      }

      if (
        event.pointerType === 'mouse' &&
        event.button !== 0
      ) {
        return;
      }

      isPointerDown = true;
      pointerId = event.pointerId;
      pointerStartX = event.clientX;
      pointerCurrentX = event.clientX;
      pauseTemporarily();

      if (viewport.setPointerCapture) {
        viewport.setPointerCapture(pointerId);
      }
    }

    function handlePointerMove(event) {
      if (!isPointerDown || event.pointerId !== pointerId) return;

      pointerCurrentX = event.clientX;
    }

    function handlePointerEnd(event) {
      if (!isPointerDown || event.pointerId !== pointerId) return;

      var distance = pointerCurrentX - pointerStartX;
      var threshold = Math.min(90, viewport.clientWidth * 0.12);

      isPointerDown = false;

      if (viewport.releasePointerCapture) {
        try {
          viewport.releasePointerCapture(pointerId);
        } catch (error) {
          /* Pointer capture may already be released. */
        }
      }

      pointerId = null;

      if (Math.abs(distance) >= threshold) {
        if (distance < 0) {
          next({ animate: true, restartAutoplay: false });
        } else {
          previous({ animate: true, restartAutoplay: false });
        }
      }

      resumeTemporarily();
    }

    function handleKeydown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        handlePreviousClick();
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        handleNextClick();
      }
    }

    function handleVisibilityChange() {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    }

    function handleResize() {
      window.clearTimeout(resizeTimer);

      resizeTimer = window.setTimeout(function () {
        moveTrack(false);
      }, 120);
    }

    function bind(element, eventName, handler, options) {
      if (!element) return;

      element.addEventListener(eventName, handler, options);
      cleanup.push(function () {
        element.removeEventListener(eventName, handler, options);
      });
    }

    bind(root, 'click', handleInteractiveClick);
    bind(previousButton, 'click', handlePreviousClick);
    bind(nextButton, 'click', handleNextClick);
    bind(autoplayButton, 'click', handleAutoplayClick);

    dots.forEach(function (dot) {
      bind(dot, 'click', handleDotClick);
    });

    bind(viewport, 'pointerdown', handlePointerDown);
    bind(viewport, 'pointermove', handlePointerMove);
    bind(viewport, 'pointerup', handlePointerEnd);
    bind(viewport, 'pointercancel', handlePointerEnd);
    bind(root, 'keydown', handleKeydown);
    bind(document, 'visibilitychange', handleVisibilityChange);
    bind(window, 'resize', handleResize, { passive: true });

    if (pauseOnHover) {
      bind(root, 'mouseenter', handleMouseEnter);
      bind(root, 'mouseleave', handleMouseLeave);
      bind(root, 'focusin', handleFocusIn);
      bind(root, 'focusout', handleFocusOut);
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            isVisible =
              entry.isIntersecting &&
              entry.intersectionRatio > 0.08;

            if (isVisible) {
              startAutoplay();
            } else {
              stopAutoplay();
            }
          });
        },
        { threshold: [0, 0.08, 0.25] }
      );

      observer.observe(root);
    }

    function handleShopifyBlockSelect(event) {
      var selectedSlide = event.target.closest(
        '#' + sectionId + ' [data-ks-hero-slide]'
      );

      if (!selectedSlide) return;

      var selectedIndex = parseInt(
        selectedSlide.getAttribute('data-slide-index'),
        10
      );

      isUserPaused = true;
      setAutoplayButtonState();
      stopAutoplay();
      goTo(selectedIndex, {
        animate: true,
        restartAutoplay: false
      });
    }

    bind(document, 'shopify:block:select', handleShopifyBlockSelect);

    function destroy() {
      if (destroyed) return;

      destroyed = true;
      stopAutoplay();
      window.clearTimeout(resumeTimer);
      window.clearTimeout(resizeTimer);

      if (observer) {
        observer.disconnect();
      }

      cleanup.forEach(function (removeListener) {
        removeListener();
      });

      cleanup = [];

      delete window.KashmirHeroSliders[sectionId];
    }

    window.KashmirHeroSliders[sectionId] = {
      destroy: destroy,
      goTo: goTo
    };

    function handleSectionUnload(event) {
      if (
        event.target &&
        (
          event.target.id === sectionId ||
          event.target.querySelector('#' + sectionId)
        )
      ) {
        destroy();
        document.removeEventListener(
          'shopify:section:unload',
          handleSectionUnload
        );
      }
    }

    document.addEventListener(
      'shopify:section:unload',
      handleSectionUnload
    );

    cleanup.push(function () {
      document.removeEventListener(
        'shopify:section:unload',
        handleSectionUnload
      );
    });

    moveTrack(false);
    updateControls();
    setAutoplayButtonState();

    window.setTimeout(function () {
      startAutoplay();
    }, 500);
  }

  function initAll(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    var roots = container.querySelectorAll('.ks-hero-slider');

    Array.prototype.forEach.call(roots, function (root) {
      initKashmirHeroSlider(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Theme editor re-renders a section without a full page load.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
